import commandsHttp from './commandsHttp'
import { getErrors } from '@/core/http'

export default {
	methods: {
		async deleteCommand(command) {
			try {
				const headers = {};

				if (this.apiToken) {
					headers['Authorization'] = `token ${this.apiToken}`;
				}

				await commandsHttp.delete(command.id, headers);

				const commandIndex = this.commands.findIndex(commandTest => commandTest.id === command.id);

				if (commandIndex >= 0) {
					this.commands.splice(commandIndex, 1);
				}

			} catch (response) {
				const errors = getErrors(response);

				errors.forEach((text) => {
					this.$flashMessage.show({
						type: 'error',
						text,
					});
				});
			}
		},
	},
}
